import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { PageActionTypes } from './types'
import { fetchError, fetchSuccess, fetchByNameSuccess, fetchByNameError } from './actions'
import { db } from '../../components/firebase'
import StringHelper from '../../utils/StringHelper'

import { ConvertBodyToPage, UpdateImages, Upload } from './saga-util-update'

// import pages from '../../data/pages.json'
// import paragraph from '../../data/page_paragraph.json'
// import users from '../../data/login.json'

// import images from '../../data/images.json'
// import galleries from '../../data/imagegallery.json'
// import directories from '../../data/directories.json'
// import pages from '../../data/projects/2.json'

function FindPreviousItemPromise(item: any) {
  let promise = () =>
    db
      .FindPreviousPage(item.id)
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}
function FindNextItemPromise(item: any) {
  item = item == null ? 0 : item

  let promise = () =>
    db
      .FindNextPage(item.id)
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function updatePageData(projects: any) {
  console.log(pages)
  projects.map(item => {
    if (item.data().id == 2) {
      db.GetPageDoc(item.id)
        .update({
          pages: pages
        })
        .then(function() {
          console.log('Document successfully updated!')
        })
    }
  })
}
function* handleImage(id: number) {
  try {
    let promise = () =>
      db
        .findImage(id)
        .get()
        .then(snapshot =>
          snapshot.docs.map(doc => {
            return doc.data()
          })
        )
    const res = yield promise()
    yield put(fetchSuccess(res))
  } catch (err) {
    if (err instanceof Error) {
      yield put(fetchError(err.stack!))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}
// db.onceImages().add(events[0])
// galleries.map((o: any) => {
//   db.onceGalleries().add(o)
// })
function getPagePromise() {
  let promise = () =>
    db
      .onceGetFirestorePages()
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function getPagePromiseByName(name: string, projectType: number) {
  let promise = () =>
    db
      .GetPageByName(name, projectType)
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function getUsersPromise() {
  let promise = () =>
    db
      .onceUsers()
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function getImagesPromise() {
  let promise = () =>
    db
      .onceImages()
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function decorateUser(project: any, users: any) {
  // Consolidate - e.g. add author info
  project.map((item: any, index: number) => {
    // update author data if not there
    if (item.data().author == undefined) {
      // How do we update document with author details
      let u: any = users.find((user: any) => user.data().id == item.data().authorid)
      if (u != undefined) {
        // update item with author data
        db.GetPageDoc(item.id)
          .update({
            author: {
              name: u.data().name,
              email: u.data().email,
              profile: u.data().profile
            }
          })
          .then(function() {
            console.log('Document successfully updated!')
          })
      }
    } else {
      console.log('author already defined')
    }
  })
}

function decorateImage(project: any, images: any) {
  // Consolidate - e.g. add author info
  const storageRef = db.storageRef()
  project.map((item: any, index: number) => {
    // update author data if not there
    if (item.data().cover == undefined) {
      // How do we update document with author details
      let u: any = images.find((image: any) => image.data().id == item.data().mainimage)
      if (u != undefined) {
        const image = storageRef.child(u.data().location.replace('~', ''))
        image.getDownloadURL().then(url => {
          console.log('url', url)
          // update item with author data
          db.GetPageDoc(item.id)
            .update({
              cover: {
                description: u.data().description,
                location: u.data().location,
                id: u.data().id,
                url: url
              }
            })
            .then(function() {
              console.log('Document successfully updated!')
            })
        })
      }
    } else {
      console.log('cover already defined')
    }
  })
}

function* bulkUpdate(data: any) {
  console.log('bulkUpdate', data)
  let projectType: number = data == null ? 1 : data.payload
  const projects = yield getPagePromise(projectType)
  // console.log(projects)

  for (let project of projects) {
    // console.log(project)
    // collect map of all body images to change
    // const result = yield call(updateURL, project)
    // const resultImg = yield call(updateImages, project)
  }
  // const results = yield all(calls)
  // yield put(fetchSuccess(results))
}
function* updateURL(item: any) {
  let name = item.data().name
  // console.log(name)
  name = StringHelper(name)
  // console.log(name)
  db.GetPageDoc(item.id)
    .update({
      url_name: name
    })
    .then(function() {
      console.log(
        'updateURL ',
        item.data().name,
        item.data().url_name,
        name,
        ' successfully updated!'
      )
    })
}
function* updateImage(item: any) {
  const images = yield UpdateImages(item)

  images.map(item => {
    console.log('updateImage', item)
    db.GetPageDoc(item.item.id)
      .update({
        body_old:
          item.item.data().body_old == null ? item.item.data().body : item.item.data().body_old,
        body: item.body
      })
      .then(function() {
        console.log('Document ' + item.item.name + ' successfully updated!')
      })
  })
}

function* updatePage(item: any, pages: any) {
  console.log('updatePage', item)
  console.log(pages)

  db.GetPageDoc(item.id)
    .update(pages)
    .then(function() {
      console.log('Document ' + item.data().name + ' successfully updated!', item.data().id)
    })
}
function* updatePages(items: any) {
  for (let i = 0; i < items.length; i++) {
    const pages = yield ConvertBodyToPage(items[i])
    const page = yield updatePage(items[i], pages)
  }
}
function* uploadPage(location: string, description: string) {
  // lets try to upload this image and use the resultant as the new url

  let url = yield call(Upload, location)
  console.log('uploadPage', location, url)
  return url
    .then(url => {
      return { url: url, type: 'image', label: description }
    })
    .catch(err => console.log('error', err, location))
}

function* waitPromise(obj, props) {
  return new Promise(function(resolve, reject) {
    ;(function waitForFoo() {
      let result = true
      props.map(prop => {
        if (obj.hasOwnProperty(prop)) {
          result = result && obj[prop]
        } else {
          result = false
        }
      })
      if (result) return resolve(obj)
      setTimeout(waitForFoo, 1000, { obj, props })
    })()
  })
}
function updateCategory(author: any) {
  author.category = authorsCategory.find(cat => cat.id == author.pid)
}

function multisplit(str, token, k) {
  let id = '========================'
  for (let i = 1; i < token.length; i++) {
    str = str.replace(token[i], id)
  }
  var arr = str.split(id)

  for (let i = 0; i < arr.length; i++) {
    arr[i] = { name: token[i], body: arr[i] }
  }

  return arr
}

function* updatePage(page: any) {
  // console.log("updating page ", page.name);
  page.url_name = StringHelper(page.name)
  const pagesArr = []
  const out = page.body.split('\r\n')
  for (var i = 0; i < out.length; i++) {
    const p = yield ConvertBodyToPage(out[i])
    pagesArr = pagesArr.concat(p.pages)
    if (p.cover != undefined) page.cover = p.cover
  }
  for (var i = 0; i < pagesArr.length; i++) {
    // pages[i].body = out[i].body.trim()
    pagesArr[i].title = [
      'C-LAB',
      'Internationally Recognised',
      'Activities',
      'Independent',
      'Howard Boland',
      'Laura Cinti'
    ][i]
    pagesArr[i].theme = i % 2 == 0 ? 'dark' : 'light'
    if (p.cover != undefined) page.cover = p.cover
  }
  page.pages = pagesArr
  page.description = page.pages[0].body
  page.pages.shift()
  console.log(page)
  // // upload code

  if (page.cover != undefined) {
    let coverResult = yield call(uploadPage, page.cover.url, page.name)
    coverResult
      .then((cover: any) => {
        // update cover
        page.cover = cover
        page.coverdone = true
      })
      .catch(err => {
        console.log('updating resource ', page.name, err)
      })
  }

  // console.log(page)
  // page.body.split()
  //

  // console.log(pages)
  const res = yield call(waitPromise, page, ['coverdone'])
  return res.then(page => {
    // clean up and send to database
    console.log(page)
      delete page.coverdone
      db.FindPage(page.id).get().then((data) => {
        // console.log(data)
        let doc = data.docs[0];
        console.log("doc",doc)
        if (doc!=undefined) {
          console.log("Document data:", doc.id);
          db.GetPages().doc(doc.id).set(page)
        .then(function() {
          console.log('Document '+page.name+' successfully updated!')
        })
      } else {
    //       // doc.data() will be undefined in this case
          console.log("No such document!", page.name);
            db.GetPages().add(page)
        .then(() => {
          console.log('Document '+page.name+' successfully updated!')
        })
      }
    //   }).catch(function(error) {
    //     console.log("Error getting document:", error);
    }).catch(err => {
      console.log("updating page ", page.name, err);
    });

    }
    //   // console.log('page', page)
      return page;
  })
  // gallery.then(gallery => {
  // console.log(gallery);
  // page.gallery = gallery
  // })
  //   let coverResult = yield call(uploadPage,cover)
  //   coverResult.then(cover:any => {
  //     // update cover
  //     page.cover =  cover;
  //   });
  // need to check for gallery and assemble
  // console.log(page)
}

function* uploadPages(index: number = 0, arr: array = []) {
  // console.log(index)

  // Start by adding all then just update
  let selectedPages = paragraph
  let item = selectedPages[index]
  let parent = pages[index]
  item.body = item.text
  item.name = item.header
  let author = users.find(u => u.id == parent.author)
  item.author = { id: author.id, name: author.name, email: author.email }
  delete item.text
  delete item.header
  // console.log(item)
  let res = yield call(updatePage, item)
  // //   // console.log("res", res);
  //   let resolved = { done: false };
  //   res.then((r) => {
  //     // console.log("r", r);
  //     resolved.done = true;
  //   }).catch(err => console.log("error", err))

  //   const p = yield call(waitPromise, resolved, ['done'])
  //   p.then(() =>{
  //   if (index<selectedPages.length) {
  //     arr.push(res);
  //     // const result =  yield* uploadPages(index+1, arr);
  //   }
  // })
  // if (index<selectedPages.length) {
  // const result =  yield* uploadPages(index+1, arr);
  // }

  // // const authorsRes = yield selectedPages.map(item => call(updatePage, item))
  // return arr;
}
function* handleFetch(data: any) {
  const uploadResult = yield uploadPages()
  // console.log('handle author', data)
  // try {
  //   const res = yield getPagePromise()
  //   yield put(fetchSuccess(res.map(item => item.data())))
  // } catch (err) {
  //   console.log(err)
  //   if (err instanceof Error) {
  //     yield put(fetchError(err.stack!))
  //   } else {
  //     yield put(fetchError('An unknown error occured.'))
  //   }
  // }
}

function* handleFetchByName(data: any) {
  try {
    // console.log('handleFetchByName', data.payload)

    const res = yield getPagePromiseByName(data.payload.name)

    // Update pages
    // if (res != null) {
    //   console.log('res', res[0])
    //   const imageRes = yield updateImage(res[0])
    //   const pages = yield ConvertBodyToPage(res[0])
    //   const page = yield updatePage(res[0], pages)
    // }
    // decorateUser(res, resUser)
    const resUser = yield getUsersPromise()
    let out = res.map(item => item.data())

    if (out[0] != undefined) {
      if (out[0].hasOwnProperty('url_name')) {
        // console.log('out[0]', res[0])
        const next = yield FindNextItemPromise(out[0])
        const previous = yield FindPreviousItemPromise(out[0])
        if (next[0] != null) out[0].next = next[0].data()
        if (previous[0] != null) out[0].previous = previous[0].data()
      }
      // console.log('out', out)
      yield put(fetchByNameSuccess(out))
    } else {
      yield put(fetchByNameError('no data found'))
    }
  } catch (err) {
    console.log(err)
    if (err instanceof Error) {
      yield put(fetchByNameError(err.stack!))
    } else {
      yield put(fetchByNameError('An unknown error occured.'))
    }
  }
}

function* bulkTransfer(data: any) {
  // console.log('handle')
  let projectType: number = data == null ? 1 : data.payload
  try {
    let promise = () =>
      db
        .onceGetFirestorePage(projectType)
        .get()
        .then(querySnapshot => {
          let p: any = []
          querySnapshot.docs.map(doc => p.push(doc.data()))
          return p
        })
    const res = yield promise()
    yield put(fetchSuccess(res))
  } catch (err) {
    if (err instanceof Error) {
      yield put(fetchError(err.stack!))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}
function* watchBulkTransferRequest() {
  yield takeEvery(PageActionTypes.BULK_TRANSFER, bulkTransfer)
}
// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchFetchRequest() {
  // console.log('watchFetchRequest', arguments)
  yield takeEvery(PageActionTypes.FETCH_REQUEST, handleFetch)
}
function* watchFetchByNameRequest() {
  // console.log('watchFetchByNameRequest', arguments)
  yield takeEvery(PageActionTypes.FETCH_BY_NAME_REQUEST, handleFetchByName)
}

function* watchBulkUpdate() {
  // console.log('watchBulkRequest ', arguments)
  yield takeEvery(PageActionTypes.BULK_UPDATE, bulkUpdate)
}
// We can also use `fork()` here to split our saga into multiple watchers.
function* PagesSaga() {
  yield all([
    fork(watchFetchRequest),
    fork(watchFetchByNameRequest),
    fork(watchBulkUpdate),
    fork(watchBulkTransferRequest)
  ])
}

export default PagesSaga
